import React from 'react';
import PropTypes from 'prop-types';

import { Typography, RadioGroup, FormControl, Radio, FormControlLabel } from '@mui/material';
import { StyledRadioMessage, StyledWrapperCancellationSurvey, StyledFormControl } from './CancellationSurveyStyles';

export default function CancellationSurvey({ data, name, dispatch, handleChange, selectedValue }) {
  const { title, successMessage, surveyOptionsList } = data;

  const typeButtons = {
    text: 'Cancel',
    select: 'Reschedule',
  };

  function divideStringBeforeComma(string) {
    const firstCommaIdx = string.indexOf(',');
    const textBeforeComma = string.slice(0, firstCommaIdx + 1);
    const textAfterComma = string.slice(firstCommaIdx + 1);

    return (
      <>
        <span>{textBeforeComma}</span>
        <span>{textAfterComma}</span>
      </>
    );
  }

  return (
    <StyledWrapperCancellationSurvey>
      <Typography variant="DS_h3" component="h1">
        {title}
        {name}!
      </Typography>
      <Typography variant="DS_copyMediumRegular" component="p">
        {successMessage}
      </Typography>
      <FormControl>
        <RadioGroup
          aria-labelledby="controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={selectedValue}
          onChange={handleChange}
        >
          {surveyOptionsList?.optionsList.map(option => (
            <>
              <StyledFormControl data-test="form-control" key={`radio-${option.label}`}>
                <FormControlLabel
                  value={option.cancelReason ? option.cancelReason : 'no reason given in cms'}
                  control={<Radio />}
                  label={option.label}
                  onClick={() => dispatch({ type: 'HANDLE_BUTTON_TYPE', button: typeButtons[option.type] })}
                />
              </StyledFormControl>
              {selectedValue === option.cancelReason && option.validationError && (
                <StyledRadioMessage variant="DS_copySmallRegular" component="p" id="controlled-radio-buttons-group">
                  {divideStringBeforeComma(option.validationError)}
                </StyledRadioMessage>
              )}
            </>
          ))}
        </RadioGroup>
      </FormControl>
    </StyledWrapperCancellationSurvey>
  );
}

CancellationSurvey.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    successMessage: PropTypes.string,
    validationError: PropTypes.string,
    surveyOptionsList: PropTypes.object,
  }),
};
